import { Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Table, TableHead } from "@mui/material";
import React from "react";
import InputWrapper from "../../../../layout/inputWrapper";
import AddIcon from "@mui/icons-material/AddCircleOutlineOutlined";
import RemoveIcon from "@mui/icons-material/HighlightOff";

const PlotDetailTable = ({ isModalOpen, setIsModalOpen, modalFields, control, isRescrutiny, getValues, setShowToast, removePlotNo, addPlotNo }) => {
  return (
    <Dialog open={isModalOpen} onClose={() => setIsModalOpen(false)} maxWidth="md" fullWidth>
      <DialogTitle>Add Plot Details</DialogTitle>

      <DialogContent>
        <Table>
          <TableHead>
            <tr>
              <th style={{ padding: 8 }}>Series No</th>
              <th style={{ padding: 8 }}>Plot No</th>
              <th style={{ padding: 8 }}>Action</th>
            </tr>
          </TableHead>
          <tbody>
            {modalFields &&
              modalFields?.map((item, index) => (
                <tr key={item.id}>
                  <td style={{ padding: 8 }}>{index + 1}</td>
                  <td style={{ padding: 8 }}>
                    <InputWrapper
                      name={`mapSubDetails.plotDetails[${index}].plotNo`}
                      control={control}
                      placeholder="Plot No"
                      type="textInput"
                      hasLabel={false}
                      mandatory
                      disabled={isRescrutiny}
                      validation={{
                        required: { value: true, message: "This field is required" },
                      }}
                    />
                  </td>
                  <td style={{ padding: 8 }}>
                    <IconButton onClick={() => removePlotNo(index)} color="error">
                      <RemoveIcon />
                    </IconButton>
                    {index === modalFields?.length - 1 && (
                      <IconButton
                        onClick={() => {
                          const currentPlotNo = getValues(`mapSubDetails.plotDetails[${modalFields?.length - 1}].plotNo`);

                          if (!currentPlotNo || currentPlotNo.trim() === "") {
                            setShowToast({
                              key: "true",
                              error: true,
                              message: "Please fill Plot No before adding another row.",
                            });
                            return;
                          }
                          addPlotNo({ plotNo: "" });
                        }}
                        color="primary"
                      >
                        <AddIcon />
                      </IconButton>
                    )}
                  </td>
                </tr>
              ))}
            <tr>
              <td colSpan={2} style={{ fontWeight: "bold", textAlign: "right", padding: 8 }}>
                Total Plots Entered:
              </td>
              <td style={{ fontWeight: "bold", padding: 8 }}>{modalFields?.length}</td>
            </tr>
          </tbody>
        </Table>
      </DialogContent>

      <DialogActions>
        <div
          style={{ textAlign: "right", marginTop: 16 }}
          onClick={() => {
            const currentPlotNo = getValues(`mapSubDetails.plotDetails[${modalFields?.length - 1}].plotNo`);
            console.log("Getting Values", currentPlotNo);

            if (!currentPlotNo || currentPlotNo.trim() === "") {
              setShowToast({
                key: "true",
                error: true,
                message: "Please fill Plot No before adding another row.",
              });
              return;
            }
            setIsModalOpen(false);
            setShowToast({
              key: "true",
              error: false,
              message: "Plot details saved successfully!",
            });
          }}
        >
          <Button type="button" sx={{ backgroundColor: "#157CB3", fontWeight: "bold", color: "#FFF" }}>
            Save
          </Button>
        </div>
        <Button
          type="button"
          onClick={() => {
            setIsModalOpen(false);
          }}
          sx={{ backgroundColor: "#FFF", fontWeight: "bold", color: "#157CB3" }}
        >
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PlotDetailTable;
